import { render, staticRenderFns } from "./Document_Holder.vue?vue&type=template&id=1d5fb25a&scoped=true"
import script from "./Document_Holder.vue?vue&type=script&lang=js"
export * from "./Document_Holder.vue?vue&type=script&lang=js"
import style0 from "./Document_Holder.vue?vue&type=style&index=0&id=1d5fb25a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5fb25a",
  null
  
)

export default component.exports